import RobotStatusPanel from "features/robot-teleop/components/robot-status/RobotStatusPanel";
import RobotConnectionStatus from "features/robot-teleop/components/robot-status/status-ctx/robot-connection-status";

/**
 * Status panel of the legacy (RobotPeerConnectionProvider) control pages: RobotStatusPanel
 * plus the context-driven RobotConnectionStatus column. The ConnectionManager-based
 * robot-control-page renders RobotStatusPanel directly, since RobotConnectionStatus reads
 * the legacy RobotConnectionContext.
 *
 * @param {Object|null} props.RobotStatus - normalized `robot.status` (see RobotStatusPanel)
 * @param {Object} props.RobotInfo - identity shown in the panel (see RobotStatusPanel)
 */
const RobotStatusViewer = ({ RobotStatus = null, RobotInfo = {} }) => (
  <RobotStatusPanel
    RobotStatus={RobotStatus}
    RobotInfo={RobotInfo}
    ConnectionStatus={<RobotConnectionStatus ShowAlert={true} ShowStatus={true} />}
  />
);

export default RobotStatusViewer;
